<div>
    <p>Items have been added to the patient's cart.</p>
    <p>Order ID: {{data.id}}</p>
</div>

<div style="display: flex;justify-content: center;">
    <button class="btn btn-primary" (click)="close()">OK</button>
</div>